/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChatFile } from './ChatFile';
export type ChatMessage = {
    sentAt: string;
    readAt: string | null;
    id: number;
    sentFrom: ChatMessage.sentFrom;
    type: ChatMessage.type;
    content?: string;
    file?: ChatFile;
};
export namespace ChatMessage {
    export enum sentFrom {
        THERAPIST = 'therapist',
        CLIENT = 'client',
    }
    export enum type {
        TEXT = 'text',
        FILE = 'file',
    }
}

